import { ISeoData } from '../../types/seoData';
import { createNoopReducer } from '../../utils/redux/createNoopReducer';

export const INITIAL_STATE: ISeoData = {
  description: '',
  h1: '',
  title: '',
};

export const seoDataReducer = createNoopReducer<ISeoData>(INITIAL_STATE);
